import { Injectable } from "@angular/core";
import { Route, Router, Routes } from "@angular/router";
import { LogService } from "../services/log.service";
import { AuthService } from "../services/auth.service";
import { hasValue } from "../common-functions";
interface UserData {
    Id: number;
    unique_name: string;
    LoginId?: string;
    UserRoleName: string;
    token: string;
}
@Injectable()
export class ServiceName {
    userRoll: any;
    private tokenLoaded = false;
    constructor(
        private readonly userdataService: LogService,
        private readonly router: Router,
        private readonly auth: AuthService
    ) {
    }

    private ensureUserLoaded(): void {
        if (this.tokenLoaded) {
            return;
        }
        this.tokenLoaded = true;
        this.gettoken().catch(error => {
            console.error('Error loading user tokens:', error);
        });
    }

    async gettoken() {
        const data: UserData = await this.auth.getUserTokens();
        if (hasValue(data)) {

            const userFullName = data.unique_name;
            const UserRoleName = data.UserRoleName;
            this.userdataService.setUserFullName(userFullName);
            this.userdataService.setUserRoleName(UserRoleName);

        }
    }

    canLoad(route: Route) {
        let user: any;
        let path = route.path;

        this.ensureUserLoaded();
        user = this.userdataService.getUserRoleName();
        this.userRoll = user.source._value;
        if (this.userRoll == "SuperAdmin" || this.userRoll == "Admin") {
            return true;
        } else if (this.userRoll == "QC" || this.userRoll == "Operator") {
            if (path == 'dashboard' || path == '' || path == 'client') {
                return true;
            } else {
                this.router.navigate(['/dashboard']);
            }
        }
    }

}

export const content: Routes = [
    {
        path: '',
        redirectTo: "dashboard",
        pathMatch: 'full',
        //path: "dashboard",
        //loadChildren: () => import("../../views/dashboard/dashboard.module").then((m) => m.DashboardModule),
    },
    {
        path: "dashboard",
        loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
        canLoad: [ServiceName]
        //path: "dashboard",
        //loadChildren: () => import("../../views/dashboard/dashboard.module").then((m) => m.DashboardModule),
    },


    //{
    //  path: "user",
    //  loadChildren: () => import("../../components/apps/users/users.module").then((m) => m.UsersModule),
    //},

    {
        path: "client",
        loadChildren: () => import("../../views/client/client.module").then((m) => m.ClientModule),
        canLoad: [ServiceName]
    },

    {
        path: "category",
        loadChildren: () => import("../../views/category/category.module").then((m) => m.CategoryModule),
        canLoad: [ServiceName]
    },

    {
        path: "logger",
        loadChildren: () => import("../../views/logger/logger.module").then((m) => m.LoggerModule),
        canLoad: [ServiceName]
    },
    {
        path: "license",
        loadChildren: () => import("../../views/license/license.module").then((m) => m.LicenseModule),
        canLoad: [ServiceName]
    },
    {
        path: "feedback",
        loadChildren: () => import("../../views/feedback/feedback.module").then((m) => m.FeedbackModule),
        canLoad: [ServiceName]
    },
    {
        path: "editor",
        loadChildren: () => import("../../components/editors/editor.module").then((m) => m.EditorModule),
    },
    {
        path: "chart",
        loadChildren: () => import("../../components/charts/charts.module").then((m) => m.ChartModule),
    },
    {
        path: "icons",
        loadChildren: () => import("../../components/icons/icons.module").then((m) => m.IconsModule),
    },
    {
        path: "form",
        loadChildren: () => import("../../components/forms/forms.module").then((m) => m.FormModule),
    },
    {
        path: "table",
        loadChildren: () => import("../../components/table/table.module").then((m) => m.TableModule),
    },
    {
        path: "cards",
        loadChildren: () => import("../../components/cards/cards.module").then((m) => m.CardsModule),
    },
    {
        path: "sample-page",
        loadChildren: () => import("../../components/others/sample/sample.module").then((m) => m.SampleModule),
    },
    {
        path: "search-pages",
        loadChildren: () => import("../../components/others/search-result/search-result.module").then((m) => m.SearchResultModule),
    },
];